import './google-map.scss';
import template from './google-map.vhtml';
import mapMarker from '../../../_img/i-map-marker-red.svg';

export default {
	template,
	props: {
		name: {
			type: String,
			required: true,
		},
		markerCordinates: {
			type: Array,
			default: null,
		},
		filters: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			mapName: this.name + "-map",
			map: null,
			bounds: null,
			markers: [],
			isLoading: false,
		};
	},
	watch: {
		filters() {
			if ( this.filters.hasOwnProperty('lat_lng') ) {
				this.isLoading = this.filters.lat_lng !== null ? true : false;
			}
		},
		markerCordinates() {
			if ( this.filters.lat_lng === null ) {
				return false;
			}
			this.isLoading = false;
			this.deleteMarkers();
			this.bounds = new google.maps.LatLngBounds();
			this.markerCordinates.forEach( coord => {
				const position = new google.maps.LatLng(coord.latitude, coord.longitude);
				const contentString = '<p><strong>' + coord.title + '</strong></p>' +
				'<p>' + coord.street + '</p>' +
				'<p>' + coord.city + '</p>' +
				'<p>' + coord.phone + '</p>' + 
				'<p><a target="_blank" href="' + coord.website + '" style="display: block !important; margin-top: 5px; text-decoration: underline;">Website</a></p>';
				const infowindow = new google.maps.InfoWindow({
					content: contentString
				});
				const marker = new google.maps.Marker({
					position,
					map: this.map,
					clickable: true,
					optimized: false,
					icon: {
						url: mapMarker,
						size: new google.maps.Size( 16, 22 ),
						scaledSize: new google.maps.Size( 16, 22 ),
						origin: new google.maps.Point( 0, 0 ),
						anchor: new google.maps.Point( 8, 18 )
					},
				});
				marker.addListener('click', function() {
					infowindow.open(this.map, marker);
				});
				this.markers.push( marker );
				this.map.fitBounds( this.bounds.extend( position ) );
				if ( this.map.getZoom() > 15 ) {
					this.map.setZoom( 12 );
				}
			});
		},
	},
	methods: {
		// Sets the map on all markers in the array.
		setMapOnAll( map ) {
			for (var i = 0; i < this.markers.length; i++) {
				this.markers[i].setMap( map );
			}
		},
		// Removes the markers from the map, but keeps them in the array.
		clearMarkers() {
			this.setMapOnAll( null );
		},
		// Deletes all markers in the array by removing references to them.
		deleteMarkers() {
			this.clearMarkers();
			this.markers = [];
		},
		setupMap() {
			this.bounds = new google.maps.LatLngBounds();

			const element = document.getElementById(this.mapName)
			const options = {
				zoom: 6,
				center: new google.maps.LatLng(56.8047517, 11.7724165),
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: true,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,
				gestureHandling: 'cooperative',
				styles: [
					{
						elementType: 'geometry',
						stylers: [{ color: '#f5f5f5' }]
					},
					{
						elementType: 'labels.icon',
						stylers: [{ visibility: 'off' }]
					},
					{
						elementType: 'labels.text.fill',
						stylers: [{ color: '#616161' }]
					},
					{
						elementType: 'labels.text.stroke',
						stylers: [{ color: '#f5f5f5' }]
					},
					{
						featureType: 'administrative.land_parcel',
						elementType: 'labels.text.fill',
						stylers: [{ color: '#bdbdbd' }]
					},
					{
						featureType: 'poi',
						elementType: 'geometry',
						stylers: [{ color: '#eeeeee' }]
					},
					{
						featureType: 'poi',
						elementType: 'labels.text.fill',
						stylers: [{ color: '#757575' }]
					},
					{
						featureType: 'poi.park',
						elementType: 'geometry',
						stylers: [{ color: '#e5e5e5' }]
					},
					{
						featureType: 'poi.park',
						elementType: 'labels.text.fill',
						stylers: [{ color: '#9e9e9e' }]
					},
					{
						featureType: 'road',
						elementType: 'geometry',
						stylers: [{ color: '#ffffff' }]
					},
					{
						featureType: 'road.arterial',
						elementType: 'labels.text.fill',
						stylers: [{ color: '#757575' }]
					},
					{
						featureType: 'road.highway',
						elementType: 'geometry',
						stylers: [{ color: '#dadada' }]
					},
					{
						featureType: 'road.highway',
						elementType: 'labels.text.fill',
						stylers: [{ color: '#616161' }]
					},
					{
						featureType: 'road.local',
						elementType: 'labels.text.fill',
						stylers: [{ color: '#9e9e9e' }]
					},
					{
						featureType: 'transit.line',
						elementType: 'geometry',
						stylers: [{ color: '#e5e5e5' }]
					},
					{
						featureType: 'transit.station',
						elementType: 'geometry',
						stylers: [{ color: '#eeeeee' }]
					},
					{
						featureType: 'water',
						elementType: 'geometry',
						stylers: [{ color: '#c9c9c9' }]
					},
					{
						featureType: 'water',
						elementType: 'labels.text.fill',
						stylers: [{ color: '#9e9e9e' }]
					}
				],
			}
			this.map = new google.maps.Map(element, options);
		}
	},
	mounted() {
		this.setupMap();
	},
};


// WEBPACK FOOTER //
// ./assets/_js/components/google-map/google-map.js